import { render } from "./KampagneTab.vue?vue&type=template&id=116ed057"
import script from "./KampagneTab.vue?vue&type=script&lang=js"
export * from "./KampagneTab.vue?vue&type=script&lang=js"

import "./KampagneTab.vue?vue&type=style&index=0&id=116ed057&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__